import * as React from "react";
import { Block } from "baseui/block";

import { useUser } from "kw/auth/useUser";
import { HeadingMedium } from "kanopi-components/typography";
import { Kontainer } from "kanopi-components/Layout/Kontainer";
import { PolicyListing } from "kw/policies/components/PolicyListing";
import { useActivePolicies, useInactivePolicies } from "kw/policies/hooks/usePolicies";
import { GlobalsContext } from "../../util/Globals";
import { Accordion, Panel } from "kanopi-components/Accordion";
import { PortalRow } from "kanopi-components/PortalRow";
import { BrandLogo } from "kw/components/BrandLogo/BrandLogo";

export const PolicyListingPage = () => {
  const user = useUser();
  const userName = user?.firstName
    ? `${user.firstName}${user?.lastName ? " " + user.lastName : ""}`
    : undefined;

  const { policies: activePolicies, loading: loadingActivePolicies } =
    useActivePolicies();

  const { policies: inactivePolicies, loading: loadingInactivePolicies } =
    useInactivePolicies();

  return (
    <GlobalsContext.Provider value="policies">
      <PolicyListingHeader userName={userName} />
      <PortalRow>
        <Accordion initialState={{ expanded: ["active-policies"] }}>
          <Panel
            title="Active policies"
            key="active-policies"
            overrides={{
              PanelContainer: {
                props: {
                  "data-testid": "activePoliciesPanel",
                },
              },
            }}
          >
            <Block
              marginTop={["scale600", "scale600", "scale1200", "scale1200"]}
              marginBottom={["scale600", "scale600", "scale1200", "scale1200"]}
            >
              <PolicyListing
                policies={activePolicies}
                loading={loadingActivePolicies}
                noContentMessage="No active policies"
              />
            </Block>
          </Panel>

          <Panel
            title="Inactive policies"
            key="expired-policies"
            overrides={{
              PanelContainer: {
                props: {
                  "data-testid": "expiredPoliciesPanel",
                },
              },
            }}
          >
            <Block
              marginTop={["scale600", "scale600", "scale1200", "scale1200"]}
              marginBottom={["scale600", "scale600", "scale1200", "scale1200"]}
            >
              <PolicyListing
                policies={inactivePolicies}
                loading={loadingInactivePolicies}
                noContentMessage="No previous policies"
              />
            </Block>
          </Panel>
        </Accordion>
      </PortalRow>
    </GlobalsContext.Provider>
  );
};

type TPolicyListingHeaderProps = {
  userName?: string;
};
const PolicyListingHeader = ({ userName }: TPolicyListingHeaderProps) => {
  const title = "Welcome" + (userName ? `, ${userName}` : "");

  return (
    <Kontainer>
      <Block
        flexDirection="column"
        display="flex"
        alignItems="center"
        marginTop={["scale1200", "scale1200", "scale1600", "scale1600"]}
      >
        <Block>
          <BrandLogo />
        </Block>
        <HeadingMedium>{title}</HeadingMedium>
      </Block>
    </Kontainer>
  );
};
